import React, { useState, useEffect } from 'react';
import { useSelector } from "react-redux";
import { Button, Drawer, Input, Space, Form, Select, InputNumber } from 'antd';
import { DownloadOutlined, PlusCircleFilled, EditFilled, DeleteFilled } from '@ant-design/icons';

import debounce from 'lodash/debounce';
import useAxios from './../../../CustomHooks/useAxios';
import DebounceSelect from './../../DebounceSelect'
const { TextArea } = Input;
const { Option } = Select;

export default function Edit({ item, setRefressSearch, setVisibleEdit, setSelectedItem }) {





  const hideItem = useSelector((state) => state.loginReducer.hideItem);
  const user = useSelector((state) => state.loginReducer.user);
  const { axiosi } = useAxios();
  const [form] = Form.useForm();

  const [companyid, setCompanyid] = React.useState({ value: item.company_id, label: item.company_name });

  const [nextMainDialPlainSelectedid, setNextMainDialPlainSelectedid] = useState(item.main_dialplan_id);
  const [nextMainDialPlanData, setNextMainDialPlanData] = useState(null);

  const [telout, setTelout] = useState(item.tel_id);
  const [telsoutData, setTelsoutData] = useState(null);

  const onFinishAdd = async (values) => {
    let adddata = {
      ...values,
      company_id: companyid.value,
      tel_id: telout,
      main_dialplan_id: nextMainDialPlainSelectedid
    };

    try {
      const kq = await axiosi.put(`autocall_settings/${item.id}`, adddata);
      console.log("[onFinishAdd]:kq=", kq);
      // form.resetFields();
      setSelectedItem(null);
      setVisibleEdit(false);
      setRefressSearch(pre => !pre);
    } catch (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log("error.response.data:", error.response.data);
        console.log("error.response.status:", error.response.status);
        console.log("error.response.headers:", error.response.headers);
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.log("error.request :", error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error error.message', error.message);
      }
      console.log("error.config:", error.config);
    }
  }
  const onFinishFailedAdd = (error) => {
    console.log("[onFinishFailedAdd]:error=", error);
  }


  const handleOnChangeCompanyName = async (value) => {
    setCompanyid(value);
    const kq_tels = await axiosi.get('tels', { params: { companyid: value.value, pageSize: 1000 } });
    setTelsoutData(kq_tels.data);
    setTelout(null);


    const kq_ivrplanmain = await axiosi.get('ivrplanmain', { params: { company_id: value.value, pageSize: 1000 } });
    setNextMainDialPlanData(kq_ivrplanmain.data.rows);
    setNextMainDialPlainSelectedid(null);

  }

  async function fetchUserList(company_name) {
    console.log('fetching user', company_name);
    const body = await axiosi.get('companies', { params: { company_name, pageSize: 100 } });
    if (body?.data?.rows) {
      return body?.data?.rows.map((user) => ({
        label: user.company_name,
        value: user.id,
        //  value:{id: user.id,company_code:user.company_code},
        company_code: user.company_code,
      }));
    }
    else {
      const a = [{ label: "---no data---", value: "" }]
      return a.map(i => (i))
    }

  }




  const handleOnChangeNextMainDialPlan = (value) => {
    setNextMainDialPlainSelectedid(value);
    // console.log("[handleOnChangeNextMainDialPlan]:value=", value)

    // const kq = await axiosi.get('ivrplanmain', { params: { company_id: companyid.value, pageSize: 1000 } });
    // console.log("[useEffect-getNextMainDialplan]:kq=", kq)
    // setNextMainDialPlanData(kq.data.rows);

    // const kq = await axiosi.get('tels', { params: { companyid: companyid.value, pageSize: 1000 } });
    // console.log("[useEffect-handleOnChangeCompanyName]:kq_get_tels=", kq);
    // console.log("[useEffect-handleOnChangeCompanyName]:selectedvalue=", companyid.value);
    // setTelsoutData(kq.data);

  }

  function onSearch(val) {
    console.log('search:', val);
  }
  const handleOnChangeTelsout = async (value) => {
    setTelout(value);
    console.log(value);
  }

  useEffect(() => {
    const getNextMainDialplan = async () => {
      try {
        if (companyid) {
          const kq = await axiosi.get('ivrplanmain', { params: { company_id: companyid.value, pageSize: 1000 } });
          setNextMainDialPlanData(kq.data.rows);
        } else {
          setNextMainDialPlanData(null);
        }
      }
      catch (err) {
        console.log("[useEffect-getNextMainDialplan]:err=", err);
      }

    }
    getNextMainDialplan();
  }, [])
  useEffect(() => {
    const getTeloutsid = async () => {
      const kq = await axiosi.get('tels', { params: { companyid: companyid.value, pageSize: 1000 } });
      setTelsoutData(kq.data);
    };
    getTeloutsid();
  }, [])


  return (<>

    <Form form={form}
      name="basic"
      labelCol={{ span: 9 }}
      wrapperCol={{ span: 15 }}
      initialValues={item}
      onFinish={onFinishAdd}
      onFinishFailed={onFinishFailedAdd}
      autoComplete="off"
    >


      <Form.Item className={hideItem}
        label="Company Name"

        rules={[{ required: (hideItem !== "hideItem"), message: 'Please input a company_name!' }]}
      >
        <DebounceSelect
          showSearch={true}
          value={companyid}
          placeholder="Select a company !"
          fetchOptions={fetchUserList}
          onChange={handleOnChangeCompanyName}
          style={{ width: '100%', }}
        />
      </Form.Item>
      <Form.Item
        label="Name :"
        name="token_name"
        rules={[{ required: true, message: 'Please input a survey Token Name!' }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="Main Plan IVR :"

        rules={[{ required: false, message: 'Please input an nextmaindialplanid!' }]}
      >

        <Select style={{ width: '100%' }} showSearch
          onChange={handleOnChangeNextMainDialPlan}
          //(value)=>setMenu_item_id(value)}
          // loading={menuItemDataLoading}
          value={nextMainDialPlainSelectedid}
          optionFilterProp="children"
          placeholder="Select a person"
          onSearch={onSearch}
          filterOption={(input, option) =>
            option.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }

        >
          <Option value=""></Option>
          {nextMainDialPlanData && nextMainDialPlanData.map(item => (
            <Option key={item.id} value={item.id}>{item.name}</Option>
          ))}
        </Select>


      </Form.Item>

      <Form.Item
        label="PBX Tel"
        rules={[{ required: false, message: 'Please input an pbxtel!' }]}
      >

        <Select style={{ width: '100%' }}
          onChange={handleOnChangeTelsout}
          value={telout}

        >
          <Option value=""></Option>
          {telsoutData?.rows && telsoutData.rows.map(item => (
            <Option key={item.id} value={item.id}>{item.telout}</Option>
          ))}
        </Select>



      </Form.Item>






      <Form.Item
        label="Allow IP :"
        name="allow_ips"
        rules={[{ required: false, message: 'Please input allowed IP list!' }]}
      >
        <TextArea rows={4} placeholder="1.1.1.1,2.2.2.2,3.3.3.3" />
      </Form.Item>

      <Form.Item
        label="Note :"
        name="note"
        rules={[{ required: false, message: 'Please input a survey name!' }]}
      >
        <TextArea rows={4} placeholder="Note" />
      </Form.Item>





      <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
        <Button type="primary" htmlType="submit">
          Save
        </Button>
      </Form.Item>
    </Form>
  </>);
}
